class ScrollAnimations {
	constructor() {
		this.variables();
		this.bindEvents();
	}

	variables() {
		this.arrowScroll = '.arrow-down';
		this.scrollToTopArrow = '.scroll-to-top';
		this.animateScrollingWrap = '.animated-scrolling';
	}

	bindEvents() {
		let that = this;
		$(document).on('click', this.arrowScroll, this.scrollArrow);

		if (($(window).width() < 992 || $(window).height() < 671)) {
			$(window).on('scroll touchmove', function () {
				if ($(document).scrollTop() > $(window).height()) {
					$(that.scrollToTopArrow).fadeIn();
				} else {
					$(that.scrollToTopArrow).fadeOut();
				}
			});
		}

		$(document).on('click', this.scrollToTopArrow, this.scrollToTop);

		$(window).on('scroll touchmove', function () {
			that.fadeInScroll();
		});
	}

	scrollArrow(e) {
		e.preventDefault();
		var target = $(this.hash);
		if (target.length) {
			$('html, body').stop(true, false).animate({
				scrollTop: target.offset().top - 80
			}, 600);
		}


	}

	scrollToTop(e) {
		e.preventDefault();
		$('html, body').stop(true, false).animate({
			scrollTop: 0
		}, 600);
	}

	fadeInScroll() {
		let findScroll = this.animateScrollingWrap;

		if($(findScroll).hasClass('tab-pane')) {
			findScroll = '.in.active' + findScroll;
		}

		$(findScroll + ' > div').each(function () {
			if ($(document).scrollTop() > ($(this).offset().top - $(window).height()) && !$(this).hasClass('show-animation')) {
				$(this).addClass('show-animation');
			}
		});
	}

}